/**
 * Modal shell using native **`HTMLDialogElement`** with a single close control.
 *
 * @param options - Title, body, and close button label (**catalog-backed**).
 * @returns **`dialog`**; caller appends to **`document.body`** (or mount) and calls **`showModal()`**.
 */
export function createModal(
  options: Readonly<{
    title: string;
    body: string;
    closeLabel: string;
  }>,
): HTMLDialogElement {
  const dlg = document.createElement("dialog");
  dlg.className = "qz-modal";

  const titleId = `qz-modal-title-${globalThis.crypto?.randomUUID?.() ?? String(Math.random()).slice(2, 12)}`;
  dlg.setAttribute("aria-labelledby", titleId);

  const h = document.createElement("h2");
  h.className = "qz-modal__title";
  h.id = titleId;
  h.textContent = options.title;

  const p = document.createElement("p");
  p.className = "qz-modal__body";
  p.textContent = options.body;

  const actions = document.createElement("div");
  actions.className = "qz-modal__actions";

  const closeBtn = document.createElement("button");
  closeBtn.type = "button";
  closeBtn.className = "qz-btn qz-btn--primary";
  closeBtn.textContent = options.closeLabel;
  closeBtn.addEventListener("click", () => {
    dlg.close();
  });
  actions.appendChild(closeBtn);

  dlg.appendChild(h);
  dlg.appendChild(p);
  dlg.appendChild(actions);
  return dlg;
}
